module.exports = "https://static.zego.com/_next/static/images/hero-broker-landing-page-large-2e08000cd9c5ec00efdbf4bfe2ec483e.png";